import { getEventTracker } from '@libs/eventTracking'
import {
  getFromPagePropertyFor,
  getCurrentPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { EventNames } from './common'

/**
 * [Link to spec](https://www.dropbox.com/scl/fi/2h3wqwmg0h11i58t295dd/%E3%80%90%E6%95%B8%E6%93%9A%E3%80%91%E5%80%8B%E4%BA%BA%E9%A0%81-_-%E6%94%B6%E8%97%8F%E9%A0%81.paper?dl=0&rlkey=5d0iky4ol057e1czbw5wq0vky#:uid=072262407101007699324762&h2=Sprint-43)
 */
export function trackUserProfileViewEvent(input) {
  const {
    currentPage: { pageName },
    fromPage,
  } = input
  getEventTracker().track({
    name: EventNames.USER_PROFILE_VIEW,
    properties: {
      fromPage: getFromPagePropertyFor(fromPage),
      currentPage: getCurrentPagePropertyFor(pageName),
    },
  })
}
